<script>
	import { onMount } from "svelte";

	import Animation from "../../components/AnimationCSS.svelte";
	import Animatable from "../../components/AnimatableCSS.svelte";

	import LinkButton from "../../components/LinkButton.svelte";

	export let id;
	export let section;
	export let slideProgress;
	export let content = {};
	export let animationDuration = 1400;

	let playDesktop;
	let playTablet;
  let playMobile;
  let resetDesktop;
  let resetTablet;
  let resetMobile;
	let played = false;
	let mounted = false;

	onMount(() => {
		mounted = true;
  });


  //$: if (mounted && (slideProgress === 0 || slideProgress === 1) && played) {
  $: if (mounted && (slideProgress === 0) && played) {
		resetDesktop && resetDesktop();
		resetTablet && resetTablet();
		resetMobile && resetMobile();
    played = false;
  }

	$: if (mounted && slideProgress !== 0 && slideProgress !== 1 && !played) {
		playDesktop && playDesktop();
		playTablet && playTablet();
		playMobile && playMobile();
		played = true;
	}

	const f = 1.5;

	const animationLeft = {
		translateX: {
			0: "calc(-100vw - 100%)",
			1: "calc(0vw - 0px)",
		},
		easing: "cubic-bezier(0.585, -0.010, 0.070, 1.000)",
	};

	const animationRight = {
		translateX: {
			0: "calc(100vw + 100%)",
			0.9: "calc(0vw - 0px)",
		},
		easing: "cubic-bezier(0.585, -0.010, 0.070, 1.000)",
	};
	const animationRight1 = {
		translateX: {
			0.15: "calc(100vw + 100%)",
			0.9: "calc(0vw - 0px)",
		},
		easing: "cubic-bezier(0.585, -0.010, 0.070, 1.000)",
	};
	const animationRight2 = {
		translateX: {
			0.3: "calc(100vw + 100%)",
			0.9: "calc(0vw - 0px)",
		},
		easing: "cubic-bezier(0.585, -0.010, 0.070, 1.000)",
	};

	const animationBottom = {
		translateY: {
			0: "calc(100vh + 100%)",
			1: "calc(0vw - 0px)",
		},
		easing: "cubic-bezier(0.585, -0.010, 0.070, 1.000)",
	};
	const animationBottom1 = {
		translateY: {
			0.1: "calc(100vh + 100%)",
			1: "calc(0vw - 0px)",
		},
		easing: "cubic-bezier(0.585, -0.010, 0.070, 1.000)",
	};
	const animationBottom2 = {
		translateY: {
			0.2: "calc(100vh + 100%)",
			1: "calc(0vw - 0px)",
		},
		easing: "cubic-bezier(0.585, -0.010, 0.070, 1.000)",
	};

	const animationTop = {
		translateY: {
			0: "calc(60px)",
			0.5: "calc(0vw - 0px)",
		},
		opacity: {
			0: "0",
			0.5: "1",
		},
	};

	const easing = "cubic-bezier(0.585, -0.010, 0.070, 1.000)";
</script>

<!-- DESKTOP -->
<div class="animation-container hide-on-mobile hide-on-tablet">
  <Animation duration={animationDuration} {easing} bind:play={playDesktop} bind:reset={resetDesktop}>
		<Animatable anchor="left" left="10%" top="40%" animation={animationLeft}>
			<div class="content">
				<div class="t-cta">
					<div class="t-cta-title">{@html content.heading}</div>
					<div class="t-cta-text t-red">{@html content.text}</div>
				</div>
				<LinkButton link={content.button_link} text={content.button_text} color="red" />
			</div>
		</Animatable>
		<Animatable anchor="bottomcenter" left="75%" top="75%" animation={animationRight}>
			<img class="anim" src="{PATH}assets/images/content/{section}_{id}_paper_desktop.png" alt="" width={200 * f} />
		</Animatable>
		<Animatable anchor="bottomcenter" left="calc(75% - 150px)" top="75%" animation={animationRight1}>
			<img class="anim" src="{PATH}assets/images/content/{section}_{id}_ipad_desktop.png" alt="" width={130 * f} />
		</Animatable>
		<Animatable anchor="bottomcenter" left="calc(75% + 30px)" top="75%" animation={animationRight2}>
			<img class="anim" src="{PATH}assets/images/content/{section}_{id}_iphone_desktop.png" alt="" width={60 * f} />
		</Animatable>
	</Animation>
</div>
<!-- TABLET -->
<div class="animation-container hide-on-desktop hide-on-mobile">
  <Animation duration={animationDuration} {easing} bind:play={playTablet} bind:reset={resetTablet}>
		<Animatable anchor="top" left="50%" top="5%" animation={animationTop}>
			<div class="content">
				<div class="t-cta">
					<div class="t-cta-title">{@html content.heading}</div>
					<div class="t-cta-text t-red">{@html content.text}</div>
				</div>
				<LinkButton link={content.button_link} text={content.button_text} color="red" />
			</div>
		</Animatable>
		<Animatable anchor="bottomcenter" left="50%" top="90%" animation={animationBottom}>
			<img class="anim" src="{PATH}assets/images/content/{section}_{id}_paper_desktop.png" alt="" width={200 * f} />
		</Animatable>
		<Animatable anchor="bottomcenter" left="calc(50% - 150px)" top="90%" animation={animationBottom1}>
			<img class="anim" src="{PATH}assets/images/content/{section}_{id}_ipad_desktop.png" alt="" width={130 * f} />
		</Animatable>
		<Animatable anchor="bottomcenter" left="calc(50% + 120px)" top="90%" animation={animationBottom2}>
			<img class="anim" src="{PATH}assets/images/content/{section}_{id}_iphone_desktop.png" alt="" width={60 * f} />
		</Animatable>
	</Animation>
</div>
<!-- MOBILE -->
<div class="animation-container hide-on-desktop hide-on-tablet">
  <Animation duration={animationDuration} {easing} bind:play={playMobile} bind:reset={resetMobile}>
		<Animatable anchor="top" left="50%" top="0%" animation={animationTop}>
			<div class="content">
				<div class="t-cta">
					<div class="t-cta-title">{@html content.heading}</div>
					<div class="t-cta-text t-red">{@html content.text}</div>
				</div>
				<LinkButton link={content.button_link} text={content.button_text} color="red" />
			</div>
		</Animatable>
		<Animatable anchor="bottomcenter" left="50%" top="90%" animation={animationBottom}>
			<img
				class="anim"
				src="{PATH}assets/images/content/{section}_{id}_paper_desktop.png"
				alt=""
				width={200 * f * 0.75}
			/>
		</Animatable>
		<Animatable anchor="bottomcenter" left="calc(50% - 90px)" top="90%" animation={animationBottom1}>
			<img
				class="anim"
				src="{PATH}assets/images/content/{section}_{id}_ipad_desktop.png"
				alt=""
				width={130 * f * 0.75}
			/>
		</Animatable>
		<Animatable anchor="bottomcenter" left="calc(50% + 90px)" top="90%" animation={animationBottom2}>
			<img
				class="anim"
				src="{PATH}assets/images/content/{section}_{id}_iphone_desktop.png"
				alt=""
				width={60 * f * 0.75}
			/>
		</Animatable>
	</Animation>
</div>

<style lang="scss">
	.animation-container .content .t-cta-title {
		@media (min-width: #{$breakpoint-tablet + 1px}) {
			font-size: 48px;
		}

		@media (min-width: #{$breakpoint-mobile + 1px}) and (max-width: $breakpoint-tablet) {
			font-size: 48px;
		}

		@media (max-width: $breakpoint-mobile) {
			font-size: 37px;
		}
	}

	@media (min-width: #{$breakpoint-mobile + 1px}) and (max-width: $breakpoint-tablet) {
		.content {
			display: flex;
			flex-direction: column;
			align-items: center;
		}
	}

	:global(#abo_print) {
		z-index: 1;
		width: 100%;
	}
</style>
